/**
 * Definition of all routes of the application.
 */
export const routes = {
  assets: {
    url: 'assets',
    absoluteUrl: '/assets',
  },
  groups: {
    url: 'groups',
    absoluteUrl: '/groups',
  },
  plants: {
    url: 'plants',
    absoluteUrl: '/plants',
  },
  serviceHelpDesk: {
    url: 'service-help-desk',
    absoluteUrl: '/service-help-desk',
  },
  unhandledError: {
    url: 'serverunhandlederror',
    absoluteUrl: '/serverunhandlederror',
  },
};
